
import { defineAsyncComponent } from "vue";
import DjangoFormNonFieldFeedback from "#src/vue/forms/widgets/DjangoFormNonFieldFeedback.vue"

export const widgets = {
    'DjangoCssClassSelector': defineAsyncComponent(() => import('#src/vue/forms/widgets/DjangoCssClassSelector.vue')),
    'DjangoFormFieldReadonly': defineAsyncComponent(() => import('#src/vue/forms/widgets/DjangoFormFieldReadonly.vue')),
    // Formset Delete buttons are used be remote templates. (AddMore button, for example, is not.)
    'DjangoFormsetDeleteButton': defineAsyncComponent(() => import('#src/vue/forms/widgets/DjangoFormsetDeleteButton.vue')),
    'DjangoInputWidget': defineAsyncComponent(() => import('#src/vue/forms/widgets/DjangoInputWidget.vue')),
    'DjangoSelectWidget': defineAsyncComponent(() => import('#src/vue/forms/widgets/DjangoSelectWidget.vue')),
    'DjangoRadioWidget': defineAsyncComponent(() => import('#src/vue/forms/widgets/DjangoRadioWidget.vue')),
    'MultipleChoiceWidget': defineAsyncComponent(() => import('#src/vue/forms/widgets/MultipleChoiceWidget.vue')),
    'FillRemainingButton': defineAsyncComponent(() => import('#src/vue/forms/widgets/ranked/FillRemainingButton.vue')),
    'FieldFeedback': defineAsyncComponent(() => import('#src/vue/forms/widgets/FieldFeedback.vue')),
    // voting sessions
    'RankedChoiceWidget': defineAsyncComponent(() => import('#src/vue/forms/widgets/ranked/RankedChoiceWidget.vue')),
    'BooleanChoiceWidget': defineAsyncComponent(() => import('#src/vue/forms/widgets/boolean/BooleanChoiceWidget.vue')),
    //
    'DjangoFormNonFieldFeedback': DjangoFormNonFieldFeedback,
}
